import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import utils from '@/utils';
import { TextAreaProps } from 'antd/es/input';
import TextArea from 'antd/es/input/TextArea';
import * as React from 'react';

export interface IEmrLongTextProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<TextAreaProps, 'name'> {}

const EmrLongText: React.FC<IEmrLongTextProps> = ({ disabled, name, field, labelProps = {}, ...props }) => {
  return (
    <EmrFormItem
      field={field}
      name={name}
      initialValue={disabled ? undefined : field?.default}
      {...labelProps}
      getValueProps={(v) => {
        return { value: utils.removeHTMLTags(v) };
      }}
    >
      <TextArea className={`base-text-area !h-[100px]`} {...props} disabled={disabled} />
    </EmrFormItem>
  );
};
export default EmrLongText;
